// Center the row by adjusting only the suggestion panel's own scroll.
// scrollIntoView would also scroll the document to center the row in the
// viewport, and the overlay is positioned in document coordinates while the
// dialog is fixed — a document-scroll change shears the panel off the input.
export const centerSelectedRow = (row: HTMLElement): void => {
  let panel = row.parentElement;
  while (panel && panel !== document.body && panel.scrollHeight <= panel.clientHeight) {
    panel = panel.parentElement;
  }
  if (!panel || panel === document.body) return;
  panel.scrollTop = row.offsetTop - (panel.clientHeight - row.offsetHeight) / 2;
};
